const trimTrailingSlashes = (value) => String(value || "").trim().replace(/\/+$/, "");

const isLocalBackendHost = (value) => {
  const host = String(value || "").trim().toLowerCase();

  return (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "0.0.0.0" ||
    host.endsWith(".localhost")
  );
};

const resolveBackendOrigin = () => {
  const explicitOrigin = trimTrailingSlashes(
    process.env.REACT_APP_BACKEND_BASE_URL || process.env.REACT_APP_MEDIA_BASE_URL || ""
  );

  if (explicitOrigin) {
    return explicitOrigin;
  }

  let backendHost = String(process.env.REACT_APP_URL_BACKEND || "").trim();
  if (!backendHost) {
    return "";
  }

  if (/^https?:\/\//i.test(backendHost)) {
    return trimTrailingSlashes(backendHost);
  }

  const defaultPort = Number(process.env.REACT_APP_BACKEND_PORT) ?? null;
  if(defaultPort) {
    backendHost = `${backendHost}:${defaultPort}`;
  }

  const protocol = String(
    process.env.REACT_APP_HTPP_PROTOCOL || process.env.REACT_APP_HTTP_PROTOCOL || "http://"
  ).trim();

  return trimTrailingSlashes(`${protocol}${backendHost}`);
};

export const resolveApiBaseUrl = () => {
  const explicitApiBase = trimTrailingSlashes(
    process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BACKEND_API_URL || ""
  );

  if (explicitApiBase) {
    return explicitApiBase.endsWith("/api") ? explicitApiBase : `${explicitApiBase}/api`;
  }

  const backendOrigin = resolveBackendOrigin();
  if (!backendOrigin) {
    return "/api";
  }

  return backendOrigin.endsWith("/api") ? backendOrigin : `${backendOrigin}/api`;
};

export const resolveBackendMediaBaseUrl = () => {
  const backendOrigin = resolveBackendOrigin();
  if (backendOrigin) {
    return backendOrigin;
  }

  const apiBase = resolveApiBaseUrl();
  if (!apiBase || apiBase === "/api") {
    return "";
  }

  return trimTrailingSlashes(apiBase.replace(/\/api$/i, ""));
};

export const resolveMediaUrl = (rawUrl) => {
  const normalizedRaw = String(rawUrl || "").trim();
  if (!normalizedRaw) return "";

  if (
    normalizedRaw.startsWith("http://") ||
    normalizedRaw.startsWith("https://") ||
    normalizedRaw.startsWith("blob:") ||
    normalizedRaw.startsWith("data:")
  ) {
    return normalizedRaw;
  }

  const backendBaseUrl = resolveBackendMediaBaseUrl();
  if (!backendBaseUrl) {
    return normalizedRaw;
  }

  if (normalizedRaw.startsWith("/")) {
    return `${backendBaseUrl}${normalizedRaw}`;
  }

  return `${backendBaseUrl}/${normalizedRaw}`;
};
